import { render, staticRenderFns } from "./PopularCategoryListItem.vue?vue&type=template&id=16118843&scoped=true&"
import script from "./PopularCategoryListItem.vue?vue&type=script&lang=js&"
export * from "./PopularCategoryListItem.vue?vue&type=script&lang=js&"
import style0 from "./PopularCategoryListItem.vue?vue&type=style&index=0&id=16118843&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16118843",
  null
  
)

export default component.exports